import { fontSizes } from "../../typography";
import type { NodePosition } from "./types";

export function LeftmostNodeLabel({
  node,
  compact,
}: {
  node: NodePosition;
  compact: boolean;
}) {
  const gap = compact ? 28 : 80; // More gap when centered (not compact)
  const labelX = node.x - gap;
  const labelY = node.y;
  const lineSpacing = compact ? 12 : 16;
  const maxCharsPerLine = 18;
  const nameWords = node.name.split(/\s+/);
  const nameLines: string[] = [];
  if (compact) {
    let current = "";
    for (const w of nameWords) {
      const testLine = current ? current + " " + w : w;
      if (testLine.length <= maxCharsPerLine) {
        current = testLine;
      } else {
        if (current) nameLines.push(current);
        current = w;
      }
    }
    if (current) nameLines.push(current);
  }
  const totalLines = compact ? 1 + nameLines.length : 4;
  const startOffset = (-(totalLines - 1) * lineSpacing) / 2;

  return (
    <text
      x={labelX}
      y={labelY}
      textAnchor={compact ? "end" : "middle"}
      fontSize={
        compact
          ? fontSizes.figure2CDNodeLabelsNarrow
          : fontSizes.figure2CDNodeLabels
      }
      fill="#2C2C2C"
    >
      <tspan x={labelX} dy={startOffset} fontWeight={600}>
        {node.code}
      </tspan>
      {compact ? (
        nameLines.map((line) => (
          <tspan
            key={line}
            x={labelX}
            dy={lineSpacing}
            fontSize={
              compact
                ? fontSizes.figure2CDNodeLabelsNarrow
                : fontSizes.figure2CDNodeLabels
            }
            fill="#666666"
          >
            {line}
          </tspan>
        ))
      ) : (
        <>
          <tspan x={labelX} dy={lineSpacing}>
            Electronic
          </tspan>
          <tspan x={labelX} dy={lineSpacing}>
            Integrated
          </tspan>
          <tspan x={labelX} dy={lineSpacing}>
            Circuits
          </tspan>
        </>
      )}
    </text>
  );
}

export function RightmostNodeLabel({
  node,
  compact = false,
}: {
  node: NodePosition;
  compact?: boolean;
}) {
  const gap = compact ? 18 : 25;
  const labelX = node.x + gap;
  const labelY = node.y;
  const maxCharsPerLine = 18;

  const words = node.name.split(/\s+/);
  const nameLines: string[] = [];
  let currentLine = "";

  for (const word of words) {
    const testLine = currentLine ? currentLine + " " + word : word;
    if (testLine.length <= maxCharsPerLine) {
      currentLine = testLine;
    } else {
      if (currentLine) nameLines.push(currentLine);
      currentLine = word;
    }
  }
  if (currentLine) nameLines.push(currentLine);

  const totalLines = 1 + nameLines.length;
  const lineSpacing = compact ? 12 : 16;
  const startOffset = (-(totalLines - 1) * lineSpacing) / 2;

  return (
    <text
      x={labelX}
      y={labelY}
      textAnchor="start"
      fontSize={
        compact
          ? fontSizes.figure2CDNodeLabelsNarrow
          : fontSizes.figure2CDNodeLabels
      }
      fill="#2C2C2C"
    >
      <tspan x={labelX} dy={startOffset} fontWeight={600}>
        {node.code}
      </tspan>
      {nameLines.map((line, _i) => (
        <tspan
          key={line}
          x={labelX}
          dy={lineSpacing}
          fontSize={
            compact
              ? fontSizes.figure2CDNodeLabelsNarrow
              : fontSizes.figure2CDNodeLabels
          }
          fill={compact ? "#666666" : undefined}
        >
          {line}
        </tspan>
      ))}
    </text>
  );
}
